import React from 'react';
import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Input, InputGroup, InputRightElement, Textarea, useColorMode, Spinner, } from '@chakra-ui/react';
import { __DEV__ } from '@chakra-ui/utils';
import { CheckIcon, AlertInactiveIcon } from '../icons';
export const TextField = React.forwardRef((props, ref) => {
    const { isDisabled, isInvalid, isReadOnly, isValid, label, helperText, errorText, isMultiline, errorIcon, isLoading, rightIcon, ...rest } = props;
    const { colorMode } = useColorMode();
    const colorValue = colorMode === 'light' ? 500 : 400;
    const colorScheme = isInvalid ? 'red' : isValid ? 'green' : 'gray';
    const showRightIcon = !isValid && !isInvalid && !isLoading;
    return (React.createElement(FormControl, { isDisabled: isDisabled, isInvalid: isInvalid, isReadOnly: isReadOnly },
        label && React.createElement(FormLabel, null, label),
        React.createElement(InputGroup, null,
            isMultiline ? (
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            React.createElement(Textarea, { ref: ref, colorScheme: colorScheme, ...rest })) : (
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            React.createElement(Input, { ref: ref, colorScheme: colorScheme, ...rest })),
            isInvalid && (React.createElement(InputRightElement, { padding: "3" }, errorIcon ? (errorIcon(`red.${colorValue}`)) : (React.createElement(AlertInactiveIcon, { color: `red.${colorValue}`, boxSize: 5 })))),
            isValid && (React.createElement(InputRightElement, { padding: "3" },
                React.createElement(CheckIcon, { color: `green.${colorValue}`, boxSize: 5 }))),
            isLoading && (React.createElement(InputRightElement, { padding: "3", width: "auto" },
                React.createElement(Spinner, { size: "sm" }))),
            showRightIcon && rightIcon && (React.createElement(InputRightElement, { padding: "3" }, rightIcon()))),
        errorText && React.createElement(FormErrorMessage, null, errorText),
        helperText && React.createElement(FormHelperText, null, helperText)));
});
if (__DEV__) {
    TextField.displayName = 'TextField';
}
//# sourceMappingURL=TextField.js.map